var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSite = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.8372 9.88889C13.8372 10.2868 13.521 10.6111 13.133 10.6111H1.86634C1.47835 10.6111 1.16217 10.2868 1.16217 9.88889V1.22222C1.16217 0.824278 1.47835 0.5 1.86634 0.5H5.79982L7.20815 1.94444H13.133C13.521 1.94444 13.8372 2.26872 13.8372 2.66667V9.88889ZM7.49967 13.5V10.6111V13.5ZM0.458008 13.5H14.5413H0.458008Z",
    fill: "#D9D9D9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.49967 13.5V10.6111M0.458008 13.5H14.5413M13.8372 9.88889C13.8372 10.2868 13.521 10.6111 13.133 10.6111H1.86634C1.47835 10.6111 1.16217 10.2868 1.16217 9.88889V1.22222C1.16217 0.824278 1.47835 0.5 1.86634 0.5H5.79982L7.20815 1.94444H13.133C13.521 1.94444 13.8372 2.26872 13.8372 2.66667V9.88889Z",
    stroke: "#707070",
    strokeMiterlimit: 10
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSite);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/site.bd8cbf446f806ad800083791ec396465.svg";